/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.orders.requests.modals.selectResourceType.controllers', [])

.controller('OrdersRequestsModalsSelectResourceTypeController', ['$scope', '$uibModalInstance', 'Types', function($scope, $uibModalInstance, Types) {

    $scope.ordersRequestsModalsSelectResourceType = {

      model: [],

      selectedType: false,

      errors: [],

      init: function() {
        this.model = Types || [];
      },

      done: function() {
        $uibModalInstance.close(this.selectedType);
      },

      cancel: function () {
        $uibModalInstance.dismiss('cancel');
      }

    };

    $scope.ordersRequestsModalsSelectResourceType.init();

}]);